import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import Image from 'gatsby-theme-core/src/components/image';
import dateFormat from 'gatsby-theme-pdv/src/helpers/date-format';
import { ArrowRight } from 'gatsby-theme-pdv/src/components/icons';

const PostPreview = ({
  date,
  title,
  excerpt,
  path,
  featuredImage,
  threeColumn = false,
  lang = 'nl',
}) => (
  <StyledPost lang={lang} threeColumn={threeColumn} grid={Boolean(featuredImage?.node)}>
    {featuredImage?.node && (
      <div>
        <Image
          alt={title}
          image={featuredImage.node}
        />
      </div>
    )}
    <div>
      <Date>{dateFormat(date)}</Date>
      <Title dangerouslySetInnerHTML={{ __html: title }} />
      <Content dangerouslySetInnerHTML={{ __html: excerpt }} />
      <Readmore to={path}>
        Lees verder
        <ArrowRight />
      </Readmore>
    </div>
  </StyledPost>
);

const StyledPost = styled.article`
  padding-bottom: calc(${(props) => props.theme.grid.gap} * 2);
  display: grid;
  grid-auto-rows: auto;
  grid-gap: ${(props) => props.theme.grid.gap};

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    ${(props) => props.threeColumn && css`
      .gatsby-image-wrapper {
        height: 220px;
      }
    `};
    ${(props) => props.grid && css`
      grid-gap: calc(${props.theme.grid.gap} * 2);
      grid-template-columns: ${(props.threeColumn ? '1fr 2fr' : '480px 1fr')};
    `};
  }
`;

const Date = styled.span`
  display: block;
  font-size: .8889rem;
  text-transform: uppercase;
  color: ${(props) => props.theme.gray3};
`;

const Title = styled.h2`
  word-break: break-word;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 1.556rem;
  text-transform: uppercase;
  margin: 10px 0;
`;

const Content = styled.div`
  p {
    margin: 0;
    line-height: 160%;
  }
`;

const Readmore = styled(Link)`
  display: block;
  margin-top: 10px;
  color: ${(props) => props.theme.primaryColor};
  text-decoration: none;
  &:hover {
    svg {
      margin-left: 8px;
    }
  }
  svg {
    margin-left: 4px;
    width: .4rem;
    vertical-align: middle;
    transition: margin-left .2s;
  }
`;

export default PostPreview;
